(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-product-optimizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-mobile-product-optimizer]');
    if (!section) return;

    const mainForm = document.querySelector('product-form form[action*="/cart/add"]');
    const bundleButton = section.querySelector('[data-bundle-add]');
    const addonSelect = section.querySelector('[data-addon-variant]');
    const status = section.querySelector('[data-bundle-status]');
    const sticky = section.querySelector('[data-sticky-buy]');
    const stickyButton = section.querySelector('[data-sticky-submit]');
    const mainSubmit = mainForm ? mainForm.querySelector('[type="submit"]') : null;

    if (sticky && mainSubmit) {
      stickyButton.addEventListener('click', () => mainSubmit.click());
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, { threshold: 0.05 });
      observer.observe(mainSubmit);
    }

    if (!bundleButton || !addonSelect || !mainForm) return;

    bundleButton.addEventListener('click', async () => {
      const mainVariant = mainForm.querySelector('[name="id"]');
      const quantity = mainForm.querySelector('[name="quantity"]');
      if (!mainVariant || !mainVariant.value || !addonSelect.value) return;

      bundleButton.disabled = true;
      status.textContent = 'Adding both items…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(mainVariant.value), quantity: Number(quantity ? quantity.value : 1) },
              { id: Number(addonSelect.value), quantity: 1 }
            ]
          })
        });
        if (!response.ok) throw new Error('Unable to add this combination.');
        window.location.href = '/cart';
      } catch (error) {
        status.textContent = error.message;
        bundleButton.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-product-tools"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-mobile-product-tools]');
    if (!section) return;
    const form = document.querySelector('product-form form[action*="/cart/add"]');
    const submit = form ? form.querySelector('[type="submit"]') : null;
    const sticky = section.querySelector('[data-sticky-buy]');
    const stickySubmit = section.querySelector('[data-sticky-submit]');
    if (sticky && submit) {
      stickySubmit.addEventListener('click', () => submit.click());
      new IntersectionObserver((entries) => { sticky.hidden = entries[0].isIntersecting; }, { threshold: .05 }).observe(submit);
    }
    const bundleButton = section.querySelector('[data-bundle-add]');
    const addon = section.querySelector('[data-addon-variant]');
    const status = section.querySelector('[data-bundle-status]');
    if (!bundleButton || !addon || !form) return;
    bundleButton.addEventListener('click', async () => {
      const mainVariant = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      if (!mainVariant || !mainVariant.value || !addon.value) return;
      bundleButton.disabled = true;
      status.textContent = 'Adding both items…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(mainVariant.value), quantity: Number(quantity ? quantity.value : 1) }, { id: Number(addon.value), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Unable to add this combination.');
        window.location.href = '/cart';
      } catch (error) { status.textContent = error.message; bundleButton.disabled = false; }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
